import { TmBaseError } from '@/core/error/tmBaseError'

export class TmAuthError extends TmBaseError {}
